import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {TextInput, DatePicker} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import validator from 'validator';
import {PERMISSIONS} from "../../../constants/constants";

export default class CourseInformation extends React.Component {
    static get props(){
        return{
            courseName: PropTypes.string.isRequired,
            courseNumber: PropTypes.string.isRequired,
            courseStartDate: PropTypes.string.isRequired,
            schoolTerm: PropTypes.string.isRequired,
            comments: PropTypes.string.isRequired,
            updateInputs: PropTypes.func.isRequired,
            courseId: PropTypes.string.isRequired,
            enableSubmit: PropTypes.func.isRequired,
            permissions:PropTypes.array.isRequired
        };
    }

    componentDidUpdate(prevProps , prevState) {
        if(prevProps.options.courseStartDate !== this.props.options.courseStartDate){
            this.setState({
                key: Math.random()
            });
        }
    }

    constructor (props) {
        super(props);

        this.state = {
            courseNameInputState: 'default',
            courseNameErrorMsg: null,
            courseCodeInputState: 'default',
            courseCodeErrorMsg: null,
            courseStartDateInputState: 'default',
            courseStartDateErrorMsg: null,
        };

        this.handleClassStartDateChange = this.handleClassStartDateChange.bind(this);
        this.handleCourseNameChange = this.handleCourseNameChange.bind(this);
        this.handleCourseNoChange = this.handleCourseNoChange.bind(this);
        this.handleTermChange = this.handleTermChange.bind(this);
    }

    getFormatedDates = (date) => {
        const isValid = validator.toDate(date);
        if(isValid){
            const d = new Date(date);
            const ISODATE = d.toISOString();
            const dateMoment =  moment(ISODATE).format();
            return({dateISO: ISODATE, dateMoment: dateMoment});
        }else{
            return({dateISO: '', dateMoment: ''});
        }
    };

    handleClassStartDateChange(date) {
        const NewStartDate = this.getFormatedDates(date).dateMoment;
        if(this.validateCourseStartDate(NewStartDate)){
            this.props.options.updateInputs("courseStart", NewStartDate);
            this.props.options.enableSubmit(true);
        }
        else{
            this.props.options.enableSubmit(false);
        }
    }

    handleCourseNameChange(e){
        const MAX_COURSE_LENGTH = 40;
        const inputLength = e.target.value.length;
        if(inputLength <= MAX_COURSE_LENGTH) {
            this.props.options.enableSubmit(this.validateCourseName(e.target.value));
            this.props.options.updateInputs("courseName",e.target.value);
        }
    }

    handleCourseNoChange(e){
        this.props.options.enableSubmit(this.validateCourseCode(e.target.value));
        this.props.options.updateInputs("courseNumber",e.target.value);
    }

    handleTermChange (e){
        this.props.options.enableSubmit(true);
        this.props.options.updateInputs("term",e.target.value);
    }

    validateCourseName(value) {
        const isCourseNameEmpty = validator.isEmpty(value);
        this.setState({
            courseNameInputState: isCourseNameEmpty ? 'error' : 'default',
            courseNameErrorMsg: isCourseNameEmpty ? 'Course name is required' : null
        });

        return !isCourseNameEmpty;
    }

    validateCourseCode(value) {
        const isCourseCodeEmpty = validator.isEmpty(value);
        this.setState({
            courseCodeInputState: isCourseCodeEmpty ? 'error' : 'default',
            courseCodeErrorMsg: isCourseCodeEmpty ? 'Course code is required' : null
        });

        return !isCourseCodeEmpty;
    }

    validateCourseStartDate(value) {
        const isValid = validator.toDate(value);
        this.setState({
            courseStartDateInputState: !isValid ? 'error' : 'default',
            courseStartDateErrorMsg: !isValid ? 'Invalid date' : null,
        });

        return isValid;
    }

    render(){
        const {courseStartDate, courseName} = this.props.options;
        return (
            <div className="course-info">
                <div className="pe-row course-info">
                    <div className="pe-col-4">
                        <TextInput id="courseName"
                            labelText="Course Name"
                            fancy={false}
                            changeHandler={this.handleCourseNameChange}
                            inputState= {!validator.isEmpty(this.props.options.courseId) ? 'disabled' : this.state.courseNameInputState}
                            errorMessage={this.state.courseNameErrorMsg}
                            value={this.props.options.courseName}
                            inputState={this.props.options.permissions.includes(PERMISSIONS.view_only_course_name)? 'disabled' : ''}/>
                            
                    </div>

                </div>
                <div className="pe-row course-info">
                    <div className="pe-col-4">
                        <TextInput id="courseNumber"
                            labelText="Course Number"
                            fancy={false}
                            changeHandler={this.handleCourseNoChange}
                            inputState= {!validator.isEmpty(this.props.options.courseId) ? 'disabled' :this.state.courseCodeInputState}
                            errorMessage={this.state.courseCodeErrorMsg}
                            value={this.props.options.courseNumber}
                            inputState={this.props.options.permissions.includes(PERMISSIONS.view_only_course_number)? 'disabled' : ''}
                        />
                    </div>
                </div>
                <div className="pe-row course-info" >
                    <div className="pe-col-4">
                        <TextInput id="term"
                            labelText="Term"
                            fancy={false}
                            changeHandler={this.handleTermChange}
                            inputState={!validator.isEmpty(this.props.options.courseId) ? 'disabled' : 'default'}
                            value={this.props.options.schoolTerm}
                            inputState={this.props.options.permissions.includes(PERMISSIONS.view_only_term)? 'disabled' : ''}
                        />
                    </div>
                </div>
                <div className="pe-row course-info" >
                    <div className="pe-col-4">
                        <DatePicker
                            key={this.state.key}
                            id="classStartDate"
                            dateFormat='MM/DD/YYYY'
                            labelText="Class Start Date (MM/DD/YYYY)"
                            datePickerValue={courseStartDate ? moment.utc(courseStartDate).format('MM/DD/YYYY') : null}
                            changeHandler={this.handleClassStartDateChange}
                            disablePast={true}
                            inputState={!validator.isEmpty(this.props.options.courseId) ? 'disabled' : this.state.courseStartDateInputState}
                            errorMessage={this.state.courseStartDateErrorMsg}
                            inputState={this.props.options.permissions.includes(PERMISSIONS.view_only_class_startdate)? 'disabled' : ''}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/CourseInformation.js